import { createFolderSelectors } from './folderSelectorsFactory';
import { GALLERY_FOLDER_DEVIATIONS_STREAM, GALLERY_SUBFOLDERS_STREAM } from '../../constants';

export const {
  getFolderDeviations,
  getHasDeviations,
  getSubfolders,
  getVisibleSubfolders,
  getHasSubfolders,
  getHasMoreSubfolders,
} = createFolderSelectors(
  GALLERY_FOLDER_DEVIATIONS_STREAM.streamId,
  GALLERY_SUBFOLDERS_STREAM.streamId
);
